import { useDispatch, useSelector } from "react-redux";
import "../../css/MyPage.css";
import { useEffect } from "react";
import { postPopupTrue } from "../repo/PopupAPI";
import { popupOpenState } from "../../../../common/redux/action/PopupAction";
import symbol from "../../img/Symbol.svg";
import {
  PopupButton,
  PopupMainText,
  PopupMainTitle,
  PopupNoButton,
} from "../../css/ModalStyld";
import { IoCloseOutline } from "react-icons/io5";

export default function PopupModal({ isOpen, onClose, onOpenCanclePopup }) {
  const dispatch = useDispatch();
  const popupData = useSelector((state) => state.popUpState?.popupData?.[0]);

  if (!isOpen) return null;

  const handleSuccess = async () => {
    try {
      const resp = await postPopupTrue(popupData?.id);

      if (resp.data === true) {
        dispatch(popupOpenState(false));
        onClose();
      }
    } catch (error) {
      console.log("동의 에러 ", error);
    }
  };

  const handleFail = async () => {
    try {
      onClose();
      dispatch(popupOpenState());

      if (popupData.popupCancleStart === true) {
        onOpenCanclePopup();
      }
    } catch (error) {
      console.log("미동의 에러", error);
      return;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-modal-box">
          <div
            onClick={() => handleFail()}
            style={{
              // position: `absolute`,
              display: `flex`,
              width: `100%`,
              justifyContent: `end`,
              alignItems: `center`,
              cursor: `pointer`,
            }}
          >
            <IoCloseOutline size={20} />
          </div>
          <div
            className="popup-img-box"
            style={{
              height: `65px`,
            }}
          >
            <img
              src={symbol}
              style={{
                width: `100%`,
                height: `100%`,
              }}
            />
          </div>
          {/* todo : 너무 길어지면 아래위 스크롤 적용 예정 */}
          <div
            style={{
              display: `flex`,
              flexDirection: `column`,
              alignItems: `center`,
              justifyContent: `center`,
              textAlign: `center`,
            }}
          >
            <PopupMainTitle>{popupData?.title}</PopupMainTitle>
            <PopupMainText
              dangerouslySetInnerHTML={{ __html: popupData?.content || "" }}
            />
          </div>
          <PopupButton onClick={() => handleSuccess()}>
            {popupData?.confirm_btn}
          </PopupButton>
          <div
            style={{
              height: `10px`,
            }}
          ></div>
          <PopupNoButton onClick={() => handleFail()}>
            {popupData?.cancle_btn}
          </PopupNoButton>
        </div>
      </div>
    </div>
  );
}
